import React, { FC } from 'react';
import { Tooltip } from '@clds/tooltip';
import { VersionName } from '..';
import { StyledEllipsisText } from '../CodeSnippet.styled';

interface OverflowedVersionProps {
  version: VersionName;
}

export const OverflowedVersion: FC<React.PropsWithChildren<OverflowedVersionProps>> = ({ version, ...rest }) => (
  <Tooltip title={version} {...rest}>
    <StyledEllipsisText>
      <bdi>{version}</bdi>
    </StyledEllipsisText>
  </Tooltip>
);
